var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4995 7.20361C15.6555 7.20361 18.5304 8.41003 20.6862 10.3874C20.9046 10.5864 21.2352 10.5876 21.4439 10.3789L22.3354 9.48737C22.5562 9.26659 22.5562 8.90226 22.3282 8.69113C19.7464 6.30362 16.2937 4.84385 12.4995 4.84385C8.70646 4.84385 5.25367 6.30241 2.67193 8.68992C2.44391 8.90105 2.44391 9.26539 2.66469 9.48616L3.55623 10.3777C3.76495 10.5864 4.09551 10.5852 4.31387 10.3862C6.46975 8.41003 9.34345 7.20361 12.4995 7.20361Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4993 10.9425C14.6238 10.9425 16.5638 11.7327 18.0404 13.0357C18.2624 13.2311 18.5906 13.2323 18.7981 13.0236L19.6028 12.2201C19.8235 11.9994 19.8235 11.6302 19.5919 11.4215C17.7111 9.73369 15.2258 8.70582 12.4993 8.70582C9.77402 8.70582 7.28758 9.73248 5.40798 11.4215C5.17514 11.6302 5.17634 11.9981 5.39712 12.2189L6.2018 13.0224C6.40931 13.2311 6.73745 13.2299 6.95944 13.0345C8.4361 11.7327 10.3748 10.9425 12.4993 10.9425Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4998 14.6406C13.6085 14.6406 14.6267 15.0255 15.4278 15.6697C15.6534 15.8495 15.9707 15.8531 16.1734 15.6492L16.9805 14.8421C17.2024 14.6201 17.2036 14.2461 16.9636 14.0434C15.7596 13.024 14.2009 12.4087 12.4998 12.4087C10.7987 12.4087 9.24125 13.0228 8.03724 14.0422C7.79716 14.2449 7.79836 14.6189 8.02035 14.8421L8.82744 15.648C9.03012 15.8519 9.34741 15.8482 9.57181 15.6685C10.3741 15.0255 11.3923 14.6406 12.4998 14.6406Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3418 17.4811C14.5868 17.2362 14.5542 16.82 14.2646 16.6306C13.7579 16.2976 13.1511 16.1034 12.4996 16.1034C11.8482 16.1034 11.2425 16.2976 10.7358 16.6294C10.4475 16.8188 10.4137 17.235 10.6586 17.4799L12.1112 18.9325C12.3259 19.1484 12.6746 19.1484 12.8905 18.9325L14.3418 17.4811Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.83cd3f84ce2eb5482f236b1ef763187b.svg";
export { ForwardRef as ReactComponent };